import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { PostAuth } from '../../Api/PostData';
import Swal from 'sweetalert2';
import { useAuth } from '../../context/AuthContext';
import './login.css';

const loginAlert = options => Swal.fire({
    buttonsStyling: false,
    customClass: { popup: 'login-alert', confirmButton: 'login-alert-confirm' },
    showClass: { popup: '' }, hideClass: { popup: '' },
    ...options
});

const Login = () => {

    useEffect(() => {
        document.title = "NextSense Santan - Login";
    }, []);

    const navigate = useNavigate();
    const { setAuth, isAuthenticated } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/monitoring');
        }
    }, [navigate, isAuthenticated])


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isLoading) return;
        try {
            setIsLoading(true);
            const response = await PostAuth(formData);
            if (response.status === 200) {
                loginAlert({
                    icon: 'success',
                    title: 'Login Success !',
                    text: response.data.message,
                    confirmButtonText: 'OK',
                });
                setAuth(response.data.user, response.data.token);
                navigate('/monitoring');
            }
        } catch (error) {
            if (error.response?.status === 400) {
                loginAlert({
                    icon: 'warning',
                    title: 'Not Found !',
                    text: error.response?.data?.message || 'Unable to connect. Please check your connection and try again.',
                });
            } else if (error.response?.status === 401) {
                loginAlert({
                    icon: 'info',
                    title: 'Login Failed !',
                    text: error.response?.data?.message || 'Unable to connect. Please check your connection and try again.',
                });
            } else if (error.response?.status === 500) {
                loginAlert({
                    icon: 'warning',
                    title: 'Internal Server Error !',
                    text: error.response?.data?.message || 'Unable to connect. Please check your connection and try again.',
                });
            }
            else {
                loginAlert({
                    icon: 'error',
                    title: 'Error !',
                    text: error.response?.data?.message || 'Unable to connect. Please check your connection and try again.',
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <main className="login-page">
            <div className="login-shell">
                <section className="login-form-panel" aria-labelledby="login-heading">
                    <div className="login-form-shell">
                        <Link to="/" className="login-brand" aria-label="SPB home">
                            <span className="login-brand-mark" aria-hidden="true" />
                            <img src="/assets/logo-santan.png" alt="SPB" />
                        </Link>
                        <p className="login-brand-caption">SPB · Marine IoT Monitoring System</p>
                        <header className="login-intro">
                            <h1 id="login-heading">Welcome back</h1>
                            <p>Sign in to access your marine monitoring dashboard and sensor data.</p>
                        </header>
                        <form onSubmit={handleSubmit} aria-busy={isLoading}>
                            <div className="login-field">
                                <label htmlFor="Username">Username</label>
                                <input id="Username" name="username" type="text" required autoComplete="username"
                                    value={formData.username} onChange={handleChange} placeholder="Enter your username" />
                            </div>
                            <div className="login-field">
                                <label htmlFor="Password">Password</label>
                                <div className="login-password">
                                    <input id="Password" name="password" type={showPassword ? 'text' : 'password'} required
                                        autoComplete="current-password" value={formData.password} onChange={handleChange} placeholder="Enter your password" />
                                    <button type="button" className="login-password-toggle" onClick={togglePasswordVisibility}
                                        aria-label={showPassword ? 'Hide password' : 'Show password'} aria-pressed={showPassword} aria-controls="Password">
                                        {showPassword ? <EyeOutlined aria-hidden="true" /> : <EyeInvisibleOutlined aria-hidden="true" />}
                                    </button>
                                </div>
                            </div>
                            <button type="submit" className="login-submit" disabled={isLoading}>
                                {isLoading && <span className="login-spinner" aria-hidden="true" />}
                                <span>{isLoading ? 'Signing in...' : 'Sign In'}</span>
                            </button>
                            <span className="login-sr-only" role="status" aria-live="polite">{isLoading ? 'Signing in. Please wait.' : ''}</span>
                        </form>
                    </div>
                </section>
                <section className="login-visual-panel">
                    <figure className="login-vessel">
                        <div className="login-vessel-photo">
                            <img src="/assets/kapal-santan.jpg" alt="Santan 3019 vessel" />
                        </div>
                        <figcaption>
                            <h2>Marine IoT Monitoring</h2>
                            <p>Vessel health, sensor analytics, and operational insights in one place.</p>
                        </figcaption>
                    </figure>
                </section>
            </div>
        </main>
    );
};

export default Login;
